import { render, staticRenderFns } from "./ScreenRotation.vue?vue&type=template&id=6f3dbfd0&scoped=true&"
import script from "./ScreenRotation.vue?vue&type=script&lang=js&"
export * from "./ScreenRotation.vue?vue&type=script&lang=js&"
import style0 from "./ScreenRotation.vue?vue&type=style&index=0&id=6f3dbfd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3dbfd0",
  null
  
)

export default component.exports